const reloadKey = 'stale-chunk-reload';

export async function reloadForStaleAssets(): Promise<boolean> {
  const path = `${window.location.pathname}${window.location.search}`;
  try {
    if (sessionStorage.getItem(reloadKey) === path) {
      return false;
    }
    sessionStorage.setItem(reloadKey, path);
  } catch {
    // Still try to recover if storage is blocked.
  }

  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(registration => registration.unregister()));
    } catch {
      // Continue with a regular reload.
    }
  }

  window.location.reload();
  return true;
}
